import { MarketplaceLinkType, ReviewableLinkType } from "../types";

/**
 * Array of possible marketplace link types ordered by popularity
 */
const marketplaceTypes: MarketplaceLinkType[] = [
  "openSea",
  "foundation",
  "objkt",
  "knownOrigin",
  "magicEden",
  "manifold",
  "rarible",
  "superRare",
  "async.art",
  "artstation",
  "creative market",
  "etsy",
  "shopify",
  "society6",
  "other marketplace",
];

/**
 * Array of possible link types ordered alphabetically
 */
const linkTypes: ReviewableLinkType[] = [
  "async.art",
  "discord",
  "etherscan",
  "foundation",
  "instagram",
  "knownOrigin",
  "linkedin",
  "magicEden",
  "manifold",
  "medium",
  "nifty",
  "objkt",
  "openSea",
  "personal website",
  "rarible",
  "reddit",
  "superRare",
  "telegram",
  "tiktok",
  "twitter",
  "website",
  "youtube",
];

export { linkTypes, marketplaceTypes };
